




































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { AgenteModel } from "@/models/cadastros/assistencia/agente/AgenteModel";
import { ResultadoAgenteModel } from "@/models/cadastros/assistencia/agente/ResultadoAgenteModel";
import ServicosAssistenciaService from "@/service/assistencia24h/ServicosAssistenciaService";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { FiltroAgenteModel } from "@/models/cadastros/assistencia/agente/FiltroAgenteModel";
import { ResultadoFiltroModel } from "@/models/cadastros/assistencia/ResultadoFiltroModel";

import {
  EstadosCidades,
  EstadosCidadesResponse,
} from "@/models/estados-cidades";
import axios, { AxiosResponse } from "axios";
import { filtroCadastrosStore } from "@/store/cadastros/FiltroCadastros";

@Component({
  components: {
    GsModalDialog,
  },
})
export default class ListaAgentes extends Vue {
  cabecalho= [
    { text: "CPF/ CNPJ", value: "cpfCnpj", width: "20%" },
    { text: "Nome / Razão Social", value: "nome", width: "20%" },
    { text: "Estado", value: "estados", sortable: false, width: "15%",},
    { text: "Cidade", value: "cidades", width: "20%", sortable: false },
    { text: 'Ativo', value: 'ativo', width: "15%", sortable: false },
    { text: "Ações", value: "actions", width: "30%", sortable: false }
  ];

  dialogType = "";
  showDialog = false;
  showDialogAtivarInativar = false;
  dialogTitle = "";
  dialogMessage = "";

  agenteAtivo = {
    id: 0,
    ativo: true
  };

  agenteExcluir = {
    id: 0
  };

  agentes: ResultadoAgenteModel= {
    content: []
  };


  filtro : FiltroAgenteModel = { 
    cpfCnpjFiltro: undefined,
    nomeFiltro: undefined,
    estado: undefined,
    cidade: undefined,
  };

  estados: EstadosCidades[] = [];
  cidades: string[] = [];
  estado: EstadosCidades = {cidades: [], sigla: "", nome: ""};
  cidade: string = "";

  loading = false;
  
  mounted() {
    axios
      .get<EstadosCidadesResponse>("/administrativo/json/estados-cidades.json")
      .then((resp) => (this.estados = resp.data.estados));   

      this.filtro = filtroCadastrosStore.filtroAtualAgentes || this.filtro as FiltroAgenteModel; // read state do filtro

      if (this.filtro == filtroCadastrosStore.filtroAtualAgentes) {
        this.filtrar();
      }  
  }

  @Watch("filtro.estado")
  selectCities() {
    this.cidades = [];
    if (this.filtro.estado && this.estados.length > 0) {
      this.cidades = this.estados.filter(
        (v) => v.sigla === this.filtro.estado.sigla
      )[0].cidades;
    } else {
      if (this.filtro.estado) {
        this.cidades = this.filtro.estado.cidades;
      } else {
        this.filtro.estado = undefined;
        this.filtro.cidade = undefined;
      }
    }
  }

  realizarExclusao(agente: AgenteModel) {
    this.agenteExcluir = {
      id: agente.id ?? 0
    };

    this.openDialog(
        "confirm",
        "Confirmar exclusão",
        `Deseja excluir o agente ${agente.nome} ?`
      );
  }

  excluir() {
    ServicosAssistenciaService.excluirAgente(this.agenteExcluir.id)
    .then(() => {
      this.filtrar();  
      this.openDialog('success', "Sucesso", "Exclusão do agente efetuada com sucesso.");
    })
    .catch(() => {
       this.openDialog('error', 'Erro', 'Erro ao realizar a exclusão do agente.');
    })
  }

  detalhes(agente: AgenteModel) {
    const id = agente.id!.toString();
    this.$router.push({ name: 'CadastroAgente', params: { idCliente: id } });
  }

  habilitarDesabilitarAgente(agente: AgenteModel) {
    this.agenteAtivo = {
      id: agente.id ?? 0,
      ativo: agente.ativo ?? true
    };

    if (!this.agenteAtivo.ativo){
      this.openDialogAtivarInativar(
        "confirm",
        "Confirmar inativação",
        `Deseja inativar o agente ${agente.nome} ?`
      );
    } else {
      this.openDialogAtivarInativar(
        "confirm",
        "Confirmar ativação",
        `Deseja ativar o agente ${agente.nome} ?`
      );
    }
  }

  ativarInativarAgente() {
    if (this.agenteAtivo.ativo == false) {
      ServicosAssistenciaService.inativarAgente(this.agenteAtivo.id).then(
        res => {
          this.closeDialog();
          this.openDialogAtivarInativar(
            "success",
            "Sucesso",
            "Agente inativado com sucesso."
          );
        },
        err => {
          this.closeDialog();
          this.openDialogAtivarInativar(
            "error",
            "Erro",
            "Ocorreu um erro ao inativar o agente."
          );
          console.error(err);
        }
      );
    } else {
      ServicosAssistenciaService.ativarAgente(this.agenteAtivo.id).then(
        res => {
          this.closeDialog();
          this.openDialogAtivarInativar(
            "success",
            "Sucesso",
            "Agente ativado com sucesso."
          );
        },
        err => {
          this.closeDialog();
          this.openDialogAtivarInativar(
            "error",
            "Erro",
            "Ocorreu um erro ao ativar o prestador."
          );
          console.error(err);
        }
      )
    }
  }

  closeDialogAtivarInativar(){
    if (this.agentes.content){
      const index = this.agentes.content?.findIndex(item => {
        return item.id == this.agenteAtivo.id;
      });

      this.agentes.content[index].ativo = !this.agenteAtivo.ativo;
      this.closeDialog();
    }
  }

  filtrar() {
    if (!this.filtroPreenchido()) {
      this.openDialog(
        "error",
        "Informe o filtro",
        "Informe pelo menos um campo no filtro."
      );

      this.agentes.content = [];
    } else {
        this.getData();
        filtroCadastrosStore.SET_FILTRO_AGENTE(this.filtro); // save do state do filtro
      }
  }

  getData() {
    this.loading = true;
    ServicosAssistenciaService.filtrarAgentes(
      this.filtro
    ).then(
      (res) => {
        //this.agentes.content = res.data;
        this.agentes.content = res.data.map((c: any) => {
          return {
            id: c.id,
            ativo: c.ativo,
            cpfCnpj: c.cpfCnpj,
            nome: c.nome,
            estados: c.enderecos.map((endereco: any) => endereco.estado).join(", "),
            cidades: c.enderecos.map((endereco: any) => endereco.cidade).join(", "),
          } as AgenteModel
        });
        this.loading = false;
      },
      (err) => {
        console.error(err);
        this.loading = false;
      }
    );
  }

  private filtroPreenchido(): boolean {
    return (!!this.filtro.cpfCnpjFiltro && !!this.filtro.cpfCnpjFiltro.trim()) ||
      (!!this.filtro.nomeFiltro && !!this.filtro.nomeFiltro.trim()) ||
      (!!this.filtro.estado);
  }

  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  private openDialogAtivarInativar(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialogAtivarInativar = true;
  }

  public closeDialog(): void {
    this.showDialog = false;
    this.showDialogAtivarInativar = false;
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      case "confirm":
        color = "error";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      case "confirm":
        text = "Cancelar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }
}
